import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Button, Modal, TextInput } from '@opendate-app/setlist';
import { toastSuccess, toastError } from "../../../shared/toastHelper";

const SaveAsTemplateModal = ({ open, onClose, seatingChart, context, csrfToken }) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setName(seatingChart.name || '');
  }, [open, seatingChart.name]);

  const save = () => {
    setSaving(true);
    axios.post(`/seating_charts/${seatingChart.id}/copy`, { context, name: name.trim() }, { headers: { 'X-CSRF-TOKEN': csrfToken } })
      .then(() => {
        toastSuccess(`Saved "${name.trim()}" to your venue's seat maps.`);
        onClose();
      })
      .catch((err) => toastError(err?.response?.data?.errors?.join(', ') || 'There was an error saving the seat map.'))
      .finally(() => setSaving(false));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Save as venue template"
      description="Saves a copy of this show's seat map to Settings → Ticketing → Seating Charts so new shows can use it. This show's seat map, tickets, holds and blocked-off seats don't change."
      footer={<>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={save} disabled={!name.trim() || saving}>Save template</Button>
      </>}
    >
      <TextInput label="Template name" value={name} onChange={(e) => setName(e.target.value)} />
    </Modal>
  );
};

SaveAsTemplateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  seatingChart: PropTypes.object.isRequired,
  context: PropTypes.oneOf(['admission', 'add_on']).isRequired,
  csrfToken: PropTypes.string.isRequired,
};

export default SaveAsTemplateModal;
